<template>
  <div style="width: 100%;">
    <div v-for="(group, title, ig) in priceListItems" :key="ig" class="container">
      <h4>{{ title }}</h4>
      <div v-for="(pricelistItem, ie) in group" :key="ie" class="row">

        <div class="col-4">
          {{ pricelistItem.name }} <span class="small" v-if="!pricelistItem.id">*</span>
        </div>
        <div class="col-4 align-items-center">
          <div>{{ $t("globals.price_once") }}</div>
          <b-input-group size="m" :prepend="'€' + (editable ? ' in cents' : '')">
            <b-form-input v-model="pricelistItem.price_one_time" v-if="editable"></b-form-input>
            <b-form-input v-else readonly :value="pricelistItem.price_one_time / 100"></b-form-input>
          </b-input-group>
        </div>
        <div class="col-4 align-items-center">
          <div>{{ $t("globals.price_monthly") }}</div>
          <b-input-group size="m" :prepend="'€' + (editable ? ' in cents' : '')">
            <b-form-input v-model="pricelistItem.price_per_month" v-if="editable"></b-form-input>
            <b-form-input v-else readonly :value="pricelistItem.price_per_month / 100"></b-form-input>
          </b-input-group>
        </div>
        <div v-if="editable">
          <b-btn size="sm" variant="success" class="float-right m-1" v-if="!pricelistItem.id"
            @click="create(pricelistItem.name, pricelistItem.price_one_time, pricelistItem.price_per_month, title, pricelistItem.pricelist_index)"
            :disabled="disabledButtons[pricelistItem.pricelist_index]">
            {{ $t("globals.save") }}
          </b-btn>

          <div v-else>
            <b-btn size="sm" variant="danger" class="float-right m-1" @click="destroy(pricelistItem.pricelist_index)"
              :disabled="disabledButtons[pricelistItem.pricelist_index]">
              {{ $t("globals.delete") }}
            </b-btn>
            <b-btn size="sm" variant="success" class="float-right m-1" @click="update(pricelistItem.pricelist_index)"
              :disabled="disabledButtons[pricelistItem.pricelist_index]">
              {{ $t("globals.save") }}
            </b-btn>

          </div>
        </div>

      </div>

    </div>
    <div class="container">
      *{{ $t("globals.info_from_from_first_order") }}
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { currencyFormat } from "@/helpers/price";
export default {
  props: {
    refresh: Function,
    price_list: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: () => false
    },
    id: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      fields: [
        { key: 'name', label: 'Name', class: "namecol" },
        { key: 'edit_price', label: 'Price', thClass: 'col-30' },
        { key: 'actions', label: '', thClass: 'col-30' },
      ],
      disabledButtons: {}
    }
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation", "simpleFetch"]),
    currencyFormat,
    create(name, price_one_time, price_per_month, type, index) {
      this.$set(this.disabledButtons, index, true);
      let data = {
        query: `
          mutation {
            res: ContractDetailItemCreate(
              customer_contract_detail_id: ${this.id}
              name: "${name}"
              price_one_time: ${price_one_time}
              price_per_month: ${price_per_month}
              item_type: "${type}"
            )
          }
          `
      };

      this.simpleFetch({ data, this_ref: this }).then(
        response => {
          this.$set(this.disabledButtons, index, false);
          this.refresh();
        }
      );
    },
    update(index) {
      const item = this.selectItem(index);
      this.$set(this.disabledButtons, index, true);
      if (item) {
        let data = {
          query: `
            mutation {
              res: ContractDetailItemEdit(
                id: ${item.id}
                price_one_time: ${item.price_one_time}
                price_per_month: ${item.price_per_month}
              )
            }
            `
        };
        this.simpleMutation({ data, this_ref: this }).then(() => { })
        this.$set(this.disabledButtons, index, false);
      }
    },
    destroy(index) {
      const item = this.selectItem(index);
      this.$set(this.disabledButtons, index, true);
      if (item) {
        let data = {
          query: `
            mutation {
              res: ContractDetailItemDelete(
                id: ${item.id}
              )
            }
            `
        };
        this.simpleMutation({ data, this_ref: this }).then(() => { })
        this.$set(this.disabledButtons, index, false);
        this.refresh();
      }
    },
    selectItem(index) {
      const item = this.price_list.find(item => item.pricelist_index === index);
      if (item) {
        return item
      } else {
        return false
      }
    },
    formatPrice(priceInCents) {
      return priceInCents / 100;
    }

  },
  computed: {
    priceListItems() {
      return this.price_list.reduce((groups, item, index) => {
        const type = item.item_type;

        if (!groups[type]) {
          groups[type] = [];
        }
        // added index
        item.pricelist_index = index;
        groups[type].push(item);
        return groups;
      }, {});
    },
  },
}
</script>
<style scoped>
.namecol>thead {
  background-color: red !important;
  width: 200px;
}

.col-70 {
  width: 70%;
}
</style>
